import * as MuiIcons from "@mui/icons-material";
import { SvgIconProps } from "@mui/material/SvgIcon";

export type FilledIconName = keyof typeof MuiIcons;

interface IconSwitcherProps extends SvgIconProps {
  name: FilledIconName;
}

const IconSwitcher: React.FC<IconSwitcherProps> = ({ name, ...svgProps }) => {
  const IconComponent = (
    MuiIcons as Record<string, React.JSXElementConstructor<any>>
  )[name];
  return IconComponent ? <IconComponent {...svgProps} /> : null;
};

export default IconSwitcher;
